<template>
  <div class="dropdown-modal-wrapper" style="position: relative; display:inline-block;">


    <!-- Bottone dinamico -->
    <div @click="toggleMenu" class="trigger-btn" tabindex="0">
      <slot name="trigger">
        <!-- Default se nessuno slot trigger passato -->
        <button>Apri menu</button>
      </slot>
    </div>

    <!-- Dropdown Desktop -->
    <transition name="fade">
      <div
          v-if="menuVisible && !isMobile"
          class="dropdown-menu"
          ref="dropdown"
          tabindex="-1"
      >
        <slot :closeMenu="closeMenu">
          <div style="padding:1em;">Contenuto dropdown desktop</div>
        </slot>
      </div>
    </transition>

    <!-- Modal Mobile -->
    <transition name="modal-fade">
      <div
          v-if="menuVisible && isMobile"
          class="modal-overlay"
          @click="closeMenu"
      >

        <div
            class="modal-content"
            @click.stop
            ref="modalContent"
        >
          <div class="drag-bar" @click="closeMenu"></div>
          <slot :closeMenu="closeMenu">
            <div style="padding:1em;">Contenuto modale mobile</div>
          </slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuVisible: false,
      isMobile: false,
    }
  },
  watch: {
    menuVisible(val) {
      if(this.isMobile){
        if(val) {
          this.lockBodyScroll();
        } else {
          this.unlockBodyScroll();
        }
      }
    }
  },
  mounted() {
    this.isMobile = window.matchMedia('(max-width: 767px)').matches
    window.addEventListener('resize', this.checkViewport)
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkViewport)
    document.removeEventListener('click', this.handleClickOutside)
    this.unlockBodyScroll();
  },
  methods: {
    lockBodyScroll() {
      // Blocca lo scroll/scroll elastico mobile
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed'; // Per iOS
      this._touchmoveListener = (e) => {
        const modalContent = this.$refs.modalContent;
        if (modalContent && modalContent.contains(e.target)) return;
        e.preventDefault();
      };
      document.addEventListener('touchmove', this._touchmoveListener, { passive: false });
    },
    unlockBodyScroll() {
      document.body.style.overflow = '';
      document.body.style.position = '';
      if (this._touchmoveListener) {
        document.removeEventListener('touchmove', this._touchmoveListener, { passive: false });
        this._touchmoveListener = null;
      }
    },
    checkViewport() {
      this.isMobile = window.matchMedia('(max-width: 767px)').matches
    },
    toggleMenu(e) {
      this.menuVisible = !this.menuVisible
    },
    closeMenu() {
      this.menuVisible = false
    },
    handleClickOutside(e) {
      if (this.menuVisible && !this.isMobile) {
        const dropdown = this.$refs.dropdown
        const btn = this.$el.querySelector('.trigger-btn')
        if (
            dropdown &&
            !dropdown.contains(e.target) &&
            btn &&
            !btn.contains(e.target)
        ) {
          this.closeMenu()
        }
      }
    }
  }
}
</script>

<style scoped>
/* Stili come prima... */
.modal-overlay {
  position: fixed;
  z-index: 80;
  inset: 0;
  background: var(--modal-overlay);
  backdrop-filter: blur(9px);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  transition: background 0.3s;
}
.modal-content {
  background: var(--bg-card);
  border-radius: 18px 18px 0 0;
  width: 100vw;
  max-width: 500px;
  margin-bottom: 0;
  padding: 0 1em 5em;
  box-shadow: 0 0 15px rgba(0,0,0,.16);
  animation: slideUp 0.32s cubic-bezier(.34,1.56,.64,1);
  max-height: 50vh;
  overflow-y: auto;
}
@keyframes slideUp {
  from { transform: translateY(100%); }
  to { transform: translateY(0%); }
}
.close-btn {
  margin-top: 1.5em;
  width: 100%;
  border: none;
  background: var(--bg-header);
  border-radius: 6px;
  padding: .7em 0;
  cursor: pointer;
  font-size: var(--font-size-6xl);
}
.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 170px;
  background: var(--bg-card);
  box-shadow: 0 0 10px rgba(0,0,0,.11);
  border-radius: 10px;
  z-index: 10;
}
.fade-enter-active, .fade-leave-active { transition: opacity .2s; }
.fade-enter, .fade-leave-to { opacity: 0; }
.modal-fade-enter-active, .modal-fade-leave-active { transition: opacity .3s; }
.modal-fade-enter, .modal-fade-leave-to { opacity: 0; }

.drag-bar {
  width: 48px;
  height: 5px;
  background: var(--text-op-50-platform);
  opacity: 0.5;
  border-radius: 3px;
  margin: 10px auto 1em;
}
/* MEDIA QUERIES */
@media (max-width: 600px) {
  .close-btn {
    margin-top: 1.5em;
    width: 100%;
    border: none;
    background: var(--bg-header);
    border-radius: 6px;
    padding: 0;
    min-height: 44px;
    cursor: pointer;
    font-size: var(--font-size-6xl);
    display: flex;
    align-items: center;
    justify-content: center;
    touch-action: manipulation;
  }
  .close-btn:active { opacity: 0.75; }
  .trigger-btn {
    touch-action: manipulation;
  }


}
</style>